export const useEnter = (cb: React.KeyboardEventHandler<HTMLElement>) => {
    return {
        onKeyDown: e => {
            if (e.keyCode === 13) {
                cb(e)
            }
        },
    } as {
        onKeyDown: React.KeyboardEventHandler<HTMLElement>
    }
}
